"use client";

import AppErrorFallback from "@components/molecules/AppErrorFallback";

export default function Error(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <AppErrorFallback error={props.error} source="route" />;
}
